/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import withHandleRoutesDispatch from '../../hoc/withHandleRoutesDispatch';

import FooterCta from '../../components/FooterCta';
import LoadingSpinner from '../../components/LoadingSpinner';
import useQuery from '../../hooks/useQuery';
import formatCurrency from '../../utils/formatCurrency';
import saveTableNameToLocalStorage from '../Venue/saveTableNameToLocalStorage';
import ExternalVendorLink from './ExternalVendorLink';
import Vendor from './Vendor';

const Vendors = () => {
  const { data: venueData } = useSelector((state) => state.venue);
  const { data: orderData, loading: orderLoading } = useSelector((state) => state.order);
  const { orderId, venueId } = useParams();
  const queries = useQuery();
  const tableName = queries.get('t');

  useEffect(() => {
    if (tableName) {
      saveTableNameToLocalStorage(tableName);
    }
  }, [tableName]);

  const { subtotal } = orderData || {};
  const { vendors, name, multiVendorCollection, externalLinks } = venueData || {};
  const hasVendors = !!vendors?.length;
  const hasExternalLinks = !!externalLinks?.length;
  const history = useHistory();

  const formattedSubtotal = formatCurrency(subtotal);
  const isCartEmpty = !orderData?.cart?.length;
  const isFooterCtaVisibile = !isCartEmpty && orderId;

  const handleNavigateToReviewPage = useCallback(() => {
    history.push(`/review/${venueId}/${orderId}`);
  }, [history, orderId, venueId]);

  return venueData ? (
    <div className="vendors">
      <div className="vendors__header">
        <h1>{name}</h1>
        {multiVendorCollection && (
          <p>
            Welcome! Heads-up, our kitchens can&apos;t guarantee any dishes to be totally free of
            allergens - for more detail, speak to the kitchen directly. As we&apos;re seven
            independent kitchens, food can arrive at different times - and if you&apos;re grabbing a
            drink, be ready to show ID!
          </p>
        )}
      </div>

      <div className="vendors__list">
        {hasExternalLinks &&
          externalLinks.map((externalLink) => (
            <ExternalVendorLink key={externalLink.name} externalVendorData={externalLink} />
          ))}
        {hasVendors ? (
          vendors.map((vendorData) => (
            <Vendor
              key={vendorData.id}
              vendorData={vendorData}
              venueId={venueId}
              orderId={orderId}
            />
          ))
        ) : (
          <p>No vendors found for this venue.</p>
        )}
      </div>
      {isFooterCtaVisibile && (
        <FooterCta onClick={handleNavigateToReviewPage} loading={orderLoading}>
          <span>Go to basket</span>
          <span>{formattedSubtotal}</span>
        </FooterCta>
      )}
    </div>
  ) : (
    <LoadingSpinner center />
  );
};

export default withHandleRoutesDispatch(Vendors);
